var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99971 12.43C11.7228 12.43 13.1197 11.0331 13.1197 9.31C13.1197 7.58687 11.7228 6.19 9.99971 6.19C8.27658 6.19 6.87971 7.58687 6.87971 9.31C6.87971 11.0331 8.27658 12.43 9.99971 12.43Z",
    stroke: "black",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.61971 7.49C3.58971 -1.17 16.4197 -1.16 18.3797 7.5C19.5297 12.58 16.3697 16.88 13.5997 19.54C11.5897 21.48 8.40971 21.48 6.38971 19.54C3.62971 16.88 0.469709 12.57 1.61971 7.49Z",
    stroke: "black",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationicon);
export default __webpack_public_path__ + "static/media/locationicon.d2f1e82430e86528b41e8768ae96ddfc.svg";
export { ForwardRef as ReactComponent };